// Document CRUD Reducer
// Handles document uploads, updates, and removal

import type { ClaimState, ClaimAction } from './types';

export function documentReducer(state: ClaimState, action: ClaimAction): ClaimState | null {
  switch (action.type) {
    case 'ADD_DOCUMENT':
      return {
        ...state,
        documents: [...state.documents, action.document],
        isDirty: true,
      };

    case 'UPDATE_DOCUMENT':
      return {
        ...state,
        documents: state.documents.map((doc) =>
          doc.id === action.id ? { ...doc, ...action.updates } : doc
        ),
      };

    case 'REMOVE_DOCUMENT':
      return {
        ...state,
        documents: state.documents.filter((doc) => doc.id !== action.id),
        isDirty: true,
      };

    default:
      return null;
  }
}
